import crownPacificFineFoodsLogo from "/img/integration/crownpacificfinefoods.png"
import { ConnectEmailPage } from "../connect-email-page"

export function ConnectCrownPacificFineFoodsPage() {
  return (
    <ConnectEmailPage
      logo={crownPacificFineFoodsLogo}
      logoAlt="Crown Pacific Fine Foods"
      integrationName="crownpacificfinefoods"
      description="Crown Pacific Fine Foods sends deduction and dispute information via email. Connect the email account(s) that receive Crown Pacific Fine Foods communications."
      redirectTo="/setup/config/crownpacificfinefoods"
    />
  )
}
